import { render, staticRenderFns } from "./FileSystemSubmenu.vue?vue&type=template&id=d37386ea"
import script from "./FileSystemSubmenu.vue?vue&type=script&lang=js"
export * from "./FileSystemSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports